<div
  class="home-book-widget w-screen max-w-[343px] tablet:max-w-[520px] laptop:max-w-[928px] ultrawide:max-w-[1152px] px-[2px] laptop:px-[unset]"
>
  <idp-guided-navigation-error-mach-core
    *ngIf="guidedNavigationErrorMsg"
    [errorMessage]="guidedNavigationErrorMsg"
  ></idp-guided-navigation-error-mach-core>
  <ng-container
    [ngTemplateOutlet]="isDesktop ? desktopView : mobileView"
  ></ng-container>
  <ng-template #desktopView>
    <idp-home-book-widget-desktop-ow-rt
      *ngIf="
        bookWidgetFields?.tripTypesField?.selectedTripType !==
        tripTypeOptions.MULTI_CITY
      "
      (infoIconClick)="infoIconClickHandler($event)"
      [bookWidgetAem]="bookWidgetAem!"
      [bookWidgetFields]="bookWidgetFields!"
      [recentSearchList]="recentSearchList"
      [savedSearchList]="savedSearchList"
      [searchModalTabs]="searchModalTabs"
      [isFullscreen]="!isDesktop"
      [predictiveSearchData]="predictiveSearchData"
      [datepickerConfig]="datepickerConfig"
      [isAdvancedSearchExpanded]="isAdvancedSearchExpanded"
      (bookWidgetFieldChange)="bookWidgetFieldChange.emit($event)"
      (swapClicked)="swapAirports.emit($event)"
      (findFlight)="findFlightClickHandler()"
      (searchModalEvent)="searchModalEvent.emit($event)"
      (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
      (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
      (toggleAdvSearchExpandedEvent)="toggleAdvSearchExpanded()"
      (analyticsEvent)="analyticsEvent.emit($event)"
    ></idp-home-book-widget-desktop-ow-rt>
    <idp-multi-city-desktop-home
      *ngIf="
        bookWidgetFields?.tripTypesField?.selectedTripType ===
        tripTypeOptions.MULTI_CITY
      "
      [bookWidgetAem]="bookWidgetAem!"
      [bookWidgetFields]="bookWidgetFields!"
      [recentSearchList]="recentSearchList"
      [savedSearchList]="savedSearchList"
      [searchModalTabs]="searchModalTabs"
      [isFullscreen]="!isDesktop"
      [predictiveSearchData]="predictiveSearchData"
      [datepickerConfig]="datepickerConfig"
      [isAdvancedSearchExpanded]="isAdvancedSearchExpanded"
      (bookWidgetFieldChange)="bookWidgetFieldChange.emit($event)"
      (swapClicked)="swapAirports.emit($event)"
      (findFlight)="findFlightClickHandler()"
      (searchModalEvent)="searchModalEvent.emit($event)"
      (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
      (infoIconClick)="infoIconClickHandler($event)"
      (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
      (addFlight)="addFlightsForMc.emit()"
      (removeFlight)="removeFlightForMc.emit()"
      (toggleAdvSearchExpandedEvent)="toggleAdvSearchExpanded()"
      (analyticsEvent)="analyticsEvent.emit($event)"
    ></idp-multi-city-desktop-home>
  </ng-template>
  <ng-template #mobileView>
    <idp-home-book-widget-mobile-ow-rt
      *ngIf="
        bookWidgetFields?.tripTypesField?.selectedTripType !==
        tripTypeOptions.MULTI_CITY
      "
      (infoIconClick)="infoIconClickHandler($event)"
      [bookWidgetAem]="bookWidgetAem!"
      [bookWidgetFields]="bookWidgetFields!"
      [recentSearchList]="recentSearchList"
      [savedSearchList]="savedSearchList"
      [searchModalTabs]="searchModalTabs"
      [isFullscreen]="!isDesktop"
      [predictiveSearchData]="predictiveSearchData"
      [datepickerConfig]="datepickerConfig"
      [viewSearchOptionExpanded]="viewSearchOptionExpanded"
      [isAdvancedSearchExpanded]="isAdvancedSearchExpanded"
      (bookWidgetFieldChange)="bookWidgetFieldChange.emit($event)"
      (swapClicked)="swapAirports.emit($event)"
      (findFlight)="findFlightClickHandler()"
      (searchModalEvent)="searchModalEvent.emit($event)"
      (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
      (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
      (viewSearchOptionEvent)="onViewSearchOptionsHandler()"
      (toggleAdvSearchExpandedEvent)="toggleAdvSearchExpanded()"
      (analyticsEvent)="analyticsEvent.emit($event)"
    ></idp-home-book-widget-mobile-ow-rt>
    <idp-multi-city-mobile-home
      *ngIf="
        bookWidgetFields?.tripTypesField?.selectedTripType ===
        tripTypeOptions.MULTI_CITY
      "
      [bookWidgetAem]="bookWidgetAem!"
      [bookWidgetFields]="bookWidgetFields!"
      [recentSearchList]="recentSearchList"
      [savedSearchList]="savedSearchList"
      [searchModalTabs]="searchModalTabs"
      [isFullscreen]="!isDesktop"
      [predictiveSearchData]="predictiveSearchData"
      [datepickerConfig]="datepickerConfig"
      [viewSearchOptionExpanded]="viewSearchOptionExpanded"
      [isAdvancedSearchExpanded]="isAdvancedSearchExpanded"
      (bookWidgetFieldChange)="bookWidgetFieldChange.emit($event)"
      (swapClicked)="swapAirports.emit($event)"
      (findFlight)="findFlightClickHandler()"
      (searchModalEvent)="searchModalEvent.emit($event)"
      (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
      (infoIconClick)="infoIconClickHandler($event)"
      (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
      (addFlight)="addFlightsForMc.emit()"
      (removeFlight)="removeFlightForMc.emit()"
      (viewSearchOptionEvent)="onViewSearchOptionsHandler()"
      (toggleAdvSearchExpandedEvent)="toggleAdvSearchExpanded()"
      (analyticsEvent)="analyticsEvent.emit($event)"
    ></idp-multi-city-mobile-home>
  </ng-template>

  <idp-info-modal-mach-core
    [showDialog]="showDialog"
    [content]="infoPopUpModalData"
    (close)="closeModal()"
  ></idp-info-modal-mach-core>
</div>
